import type { Meta, StoryFn } from '@storybook/react';

import { DatePicker, TimePicker } from '@pega/cosmos-react-core';
import type { DatePickerProps, TimePickerProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/DateTime/Picker'
} as Meta;

export const DatePickerDemo: StoryFn<DatePickerProps> = (args: DatePickerProps) => {
  const currentYear = new Date().getFullYear();
  const minYear = new Date(currentYear - (args.min as number), 0, 1);
  const maxYear = new Date(currentYear + (args.max as number), 11, 31);

  return (
    <DatePicker
      selected={new Date()}
      showWeekNumber={args.showWeekNumber}
      mode={args.mode}
      min={minYear}
      max={maxYear}
    />
  );
};

DatePickerDemo.args = {
  showWeekNumber: false,
  mode: 'date',
  min: 10,
  max: 10
};

DatePickerDemo.argTypes = {
  showWeekNumber: { control: { type: 'boolean' } },
  mode: { options: ['date', 'week', 'datetime'], control: { type: 'select' } },
  min: { control: { type: 'number' } },
  max: { control: { type: 'number' } }
};

export const TimePickerDemo: StoryFn<TimePickerProps> = (args: TimePickerProps) => {
  return (
    <TimePicker
      selected={new Date()}
      interval={args.interval}
      clockFormat={args.clockFormat}
      onSelect={() => {}}
    />
  );
};

TimePickerDemo.args = {
  interval: 30,
  clockFormat: undefined
};

TimePickerDemo.argTypes = {
  interval: { options: [undefined, 15, 30, 60], control: { type: 'select' } },
  clockFormat: { options: [undefined, 12, 24], control: { type: 'select' } }
};
